<template>
  
  <div class="bg-[#464851] text-white rounded-xl p-4"  v-if="loading">
    <block-loading/>
  </div>

  <div class="pb-2"  v-else>
    <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between items-center">
        <h2 class="font-semibold leading-tight text-2xl mt-0">Merge Product</h2>
        <span @click="closeMergeProducts" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
      </div>
    </div>

    <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
      <div class="max-h-[600px] pr-5 pl-2">
        <div class="border border-theme-green bg-theme-green/[0.3] rounded-lg px-2 py-2 mt-4">
            <business-search-select placeholder="Search" :selectedIds="data" @select="selectForceProductItem" />
            <div class="grid grid-cols-2 gap-1 mt-2 mb-1">
                <button @click="forceMerge=false" class="bg-theme-green hover:bg-theme-green-300 border-theme-green w-full border rounded uppercase  py-2">Back</button>
                <button :disabled="!mergeProduct?.id" class="w-full border border-theme-green rounded uppercase py-2" :class="(mergeProduct?.id)?'bg-theme-green hover:bg-theme-green-300 border-theme-green':'border-transparent bg-field-black text-theme-modalbg'" @click="confirmForceMerge">Confirm</button>
            </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent } from 'vue';
import BusinessSearchSelect from './businessSearchSelect'
import {mapGetters, mapMutations} from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import ProductApi from '@/controllers/BusinessProductApis'
import Helpers from '@/helpers'

export default defineComponent({
    props: ['data'],
    components: {
        BusinessSearchSelect,
    },
    setup() {
        const snackbar = useSnackbar();
        const subVariant = ref(false)
        const mergeProduct = ref({})

        return {snackbar, subVariant, mergeProduct}
    },
    computed: {
        ...mapGetters({
            vg_locationSelected: "location/selected",
        })
    },
    methods: {
        selectForceProductItem({type, productObj}){
            this.subVariant = type
            this.mergeProduct = productObj
        },
        async confirmForceMerge(){
            if(this.data?.length>0){
                this.vm_spinner(true)
                let variantIds = this.data.map(each => parseInt(each))
                let mergeData = {
                    variantIds: variantIds,
                    locationId: this.vg_locationSelected.id
                }
                let mergeProduct = null 
                if(this.subVariant){
                    mergeProduct = await ProductApi.mergeProductInSubVariant(this.mergeProduct.id, mergeData)
                }else{
                    mergeProduct = await ProductApi.mergeProductAssigningVariant(this.mergeProduct.id, mergeData)
                }
                this.snackbar.add({
                    type: 'info',
                    text: mergeProduct.status==201?"Product merged.":Helpers.catchErrorMessage(mergeProduct.response.data),
                    duration: 3000,
                })
                this.$emit('close')
                this.emitter.emit('reloadProductList')
                this.vm_spinner(false)
            }
        },
        closeMergeProducts() {
            this.$emit('close')
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>
